var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequests({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 14.9167C10.25 15 10.1667 15 10 15C9.83333 15 9.75 15 9.58333 14.9167L0 9.75V19.1667C0 19.6667 0.333333 20 0.833333 20H19.1667C19.6667 20 20 19.6667 20 19.1667V9.75L10.4167 14.9167Z",
    fill: "#4E5459"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5V1.66667H15V6.66667V10.5L19.25 8.16667L16.6667 6.25V0.833333C16.6667 0.333333 16.3333 0 15.8333 0H4.16667C3.66667 0 3.33333 0.333333 3.33333 0.833333V6.33333L0.75 8.25L5 10.5Z",
    fill: "#9CA2A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 4.16602H6.66663V5.83268H13.3333V4.16602Z",
    fill: "#4E5459"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 7.5H6.66663V9.16667H13.3333V7.5Z",
    fill: "#4E5459"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequests);
export default __webpack_public_path__ + "static/media/requests.805a5eaaae2a4584c93204096e59b49a.svg";
export { ForwardRef as ReactComponent };